module.exports = __webpack_public_path__ + "img/pic-paging-aiot-2.5570e843.jpg";